import axios from 'axios';
import API from "../config/API";
import siteSetting from "../config/env";

export const salonService = {
    searchSalonV2,
    updateSalon,
    getOpeningHours,
    updateOpeningHours,
    updateSalonSettings,
    getSalonSettings,
    uploadGalleryImage,
    deleteGalleryImage,
    reorderGalleryImages,
    getBookingLink,
    previewBookingLink,
    updateBookingLink,
    revertBookingLink
};

function _authHeaders() {
    return { 'accessToken': localStorage.getItem('accessToken') };
}

function getBookingLink(salonId) {
    return axios.get(`${API.SALON_PROFILE}${salonId}/booking-link`, { headers: _authHeaders() });
}

function previewBookingLink(salonId, name) {
    return axios.get(`${API.SALON_PROFILE}${salonId}/booking-link-preview`, { headers: _authHeaders(), params: { name } });
}

function updateBookingLink(salonId, name) {
    return axios.put(`${API.SALON_PROFILE}${salonId}/booking-link`, { name }, { headers: _authHeaders() });
}

function revertBookingLink(salonId) {
    return axios.post(`${API.SALON_PROFILE}${salonId}/booking-link/revert`, {}, { headers: _authHeaders() });
}



// v2 salon search for professional signup. PUBLIC (signup is pre-auth) — no
// Bearer token, no legacy clientId/clientSecret. Hits /api/v2/salon/search,
// which includes unclaimed/imported salons. Response: v2 envelope, salons in
// `responseData` (array of {_id, salonName, formattedAddress, isClaimed}).
function searchSalonV2(keyword) {
    const headers = { 'Content-Type': 'application/json' };
    return axios.get(API.SALON_SEARCH_V2, { params: { q: keyword }, headers });
}


function updateSalon(params) {
    let accessToken = localStorage.getItem('accessToken');
    
    // Extract salonId from FormData
    let salonId = params.get('salonId');
    
    // Convert FormData to JSON object for v2 API
    const jsonData = {};
    for (let [key, value] of params.entries()) {
        if (key !== 'clientId' && key !== 'clientSecret' && key !== 'deviceToken') {
            jsonData[key] = value;
        }
    }
    
    // Check if there's an image file to upload
    const imageFile = params.get('image');
    const hasImage = imageFile && imageFile instanceof File && imageFile.size > 0;
    
    if (hasImage) {
        // If there's an image, use multipart/form-data with the v2 settings endpoint
        let headers = {
            'Content-Type': 'multipart/form-data',
            'accessToken': accessToken
        };
        return axios.put(`${API.SALON_OPENING_HOURS}/${salonId}/settings`, params, { headers: headers });
    } else {
        // No image, use JSON with the v2 settings endpoint
        let headers = {
            'Content-Type': 'application/json',
            'accessToken': accessToken
        };
        return axios.put(`${API.SALON_OPENING_HOURS}/${salonId}/settings`, jsonData, { headers: headers });
    }
}

function getOpeningHours(salonId) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    return axios.get(`${API.SALON_OPENING_HOURS}/${salonId}/opening-hours`, { headers: headers })
}
function updateOpeningHours(salonId, opening_hours) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    return axios.put(`${API.SALON_OPENING_HOURS}/${salonId}/opening-hours`, { opening_hours }, { headers: headers })
}

function updateSalonSettings(salonId, settings) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    return axios.put(`${API.SALON_OPENING_HOURS}/${salonId}/settings`, settings, { headers: headers })
}

function getSalonSettings(salonId) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    return axios.get(`${API.SALON_OPENING_HOURS}/${salonId}/settings`, { headers: headers })
}

function uploadGalleryImage(salonId, imageFile, caption = '') {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'multipart/form-data',
        'accessToken': accessToken
    }
    
    const formData = new FormData();
    formData.append('image', imageFile);
    if (caption) {
        formData.append('caption', caption);
    }
    
    return axios.post(`${API.SALON_OPENING_HOURS}/${salonId}/gallery`, formData, { headers: headers })
}

function deleteGalleryImage(salonId, imageUrl) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    // Extract just the filename from the full URL if needed
    const filename = imageUrl.split('/').pop();
    
    return axios.delete(`${API.SALON_OPENING_HOURS}/${salonId}/gallery/${encodeURIComponent(filename)}`, { headers: headers })
}

function reorderGalleryImages(salonId, images) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'accessToken': accessToken
    }
    
    return axios.put(`${API.SALON_OPENING_HOURS}/${salonId}/gallery/reorder`, { images }, { headers: headers })
}

